import React from "react";
import "../all css/studydestination.css";
import { useNavigate } from "react-router-dom";
const country_logo1 = require("../../assets/canada.png");
const country_logo2 = require("../../assets/germany.png");
const country_logo3 = require("../../assets/us.png");
const country_logo4 = require("../../assets/aus.png");
const country_logo5 = require("../../assets/uk.png");
const country_logo6 = require("../../assets/dubai.png");

function StudyDestination(props) {
  const navigate = useNavigate();
  const handleReadmore = () => {};

  const allCountryDestinationContent = [
    {
      countryImg: country_logo1,
      countryName: "CANADA",
      nameCountry: "Canada",
      countryClassName: "country_logo_container wow bounceInLeft",
      duration: ".5s",
      delay: ".4s",
      extraCountryText:
        "With the presence of top international and local institutions, this immigration friendly country is a true hotspot. Job focused courses, and post-study work permits make it quite a favourable option for students.",
    },
    {
      countryImg: country_logo2,
      countryName: "GERMANY",
      nameCountry: "Germany",
      countryClassName: "country_logo_container wow bounceInDown",
      duration: ".5s",
      delay: ".8s",
      extraCountryText:
        " Home to leading MNCs, their innovative and cutting edge culture make Germany a land of promises for the students.",
    },
    {
      countryImg: country_logo3,
      countryName: "UNITED STATES Of America",
      nameCountry: "U.S.A",
      countryClassName: "country_logo_container wow bounceInRight",
      duration: ".5s",
      delay: "1.2s",
      extraCountryText:
        "A USA education opens doors wherever you go. With their industry-based training and research, your qualifications are recognized worldwide.",
    },
    {
      countryImg: country_logo4,
      nameCountry: "Australia",
      countryName: "AUSTRALIA",
      countryClassName: "country_logo_container wow bounceInLeft",
      duration: ".5s",
      delay: "1.6s",
      extraCountryText:
        "Globally recognized qualifications that promise excellent job and PR prospects.",
    },
    {
      countryImg: country_logo5,
      countryName: "UNITED KINGDOM",
      nameCountry: "United Kingdom ",
      countryClassName: "country_logo_container wow bounceInUp",
      duration: ".5s",
      delay: "2s",
      extraCountryText:
        "A UK education is a gateway to the world with its world-recognized universities and innovative teaching approach.",
    },
    {
      countryImg: country_logo6,
      countryName: "U.A.E",
      nameCountry: "U.A.E",
      countryClassName: "country_logo_container wow bounceInRight",
      duration: ".5s",
      delay: "2.4s",
      extraCountryText:
        "With highly job-centric courses and a supportive learning environment, it is no surprise that Dubai ranks high as one of the most popular destinations for international students.",
    },
  ];

  return (
    <section className="study_destination_main_container">
      <div className="study_destination_under_main_container">
        <div className="study_destination_title_sub_container">
          <p
            className="title_text wow pulse animated"
            data-wow-delay="500ms"
            data-wow-iteration="infinite"
            data-wow-duration="1s"
          >
            GLOBAL DESTINATION'S
          </p>
          <p className="study_destination_sub_title_text">
            One-Stop for all the BEST UNIVERSITIES across the globe
          </p>
          <p className="extra_destination_text">
            Kick start your overseas education with DWEC. Explore, discover and
            learn in the best study destinations across the globe.
          </p>
        </div>

        <div className="all_box_container">
          {allCountryDestinationContent.map((perCountryItem) => {
            return (
              <div className="each_box_container" key={Math.random()}>
                <div
                  className="logo_dashed_line_container wow bounce"
                  data-wow-duration=".5s"
                >
                  <div
                    className={perCountryItem.countryClassName}
                    data-wow-duration={perCountryItem.duration}
                    data-wow-delay={perCountryItem.delay}
                  >
                    <img
                      src={perCountryItem.countryImg}
                      alt="country"
                      className="country_logo_self"
                    />
                  </div>
                  <div className="dashed_line_destination " />
                </div>
                <div className="text_country_destination_container">
                  <p className="title_country_destionation_text">
                    {perCountryItem.nameCountry}
                  </p>
                  <p className="extra_country_destion_text">
                    {perCountryItem.extraCountryText.length > 80
                      ? perCountryItem.extraCountryText.substring(0, 80) + "..."
                      : perCountryItem.extraCountryText}
                    <a
                      href="Countries"
                      onClick={() => {
                        navigate("/Countries", {
                          state: perCountryItem.countryName,
                        });
                      }}
                      className="read_more_text_destination"
                    >
                      Read more...
                    </a>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default StudyDestination;
